var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-inner app-main-page doc-category" },
    [
      _c("div", { staticClass: "app-main-inner-row" }, [
        _c(
          "div",
          { staticClass: "triggers" },
          [
            [0, 2, 5].includes(_vm.optStatus)
              ? [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.toAdd } },
                    [_vm._v(_vm._s(_vm.addBtnText))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", disabled: _vm.optStatus === 0 },
                      on: { click: _vm.toEdit }
                    },
                    [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Edit")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger", disabled: _vm.optStatus === 0 },
                      on: { click: _vm.toDelete }
                    },
                    [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Delete")))]
                  ),
                  _vm.optStatus === 0 && _vm.$store.getters.isAdmin
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: Object.keys(_vm.currentData).length === 0,
                            type: "primary"
                          },
                          on: { click: _vm.setDefaultType }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.SetDefaultType")))]
                      )
                    : _vm._e(),
                  _vm.optStatus === 5
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.setFileSyncRule }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("SystemMaintenance.SetFileSyncRule"))
                          )
                        ]
                      )
                    : _vm._e()
                ]
              : [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.save } },
                    [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Save")))]
                  ),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.cancel } },
                    [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Cancel")))]
                  )
                ]
          ],
          2
        )
      ]),
      _vm.optStatus === 0
        ? _c(
            "el-form",
            {
              staticStyle: { margin: "15px 0 0 15px" },
              attrs: { "label-position": "left", "label-width": "85px" }
            },
            [
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "215px" },
                  attrs: { label: _vm.$t("CargoMsg.DefaultFileType") }
                },
                [
                  _c("el-input", {
                    attrs: {
                      value: _vm.currentData.defaultDocumentChineseName,
                      disabled: true
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.optStatus !== 0
        ? _c(
            "div",
            { staticClass: "app-main-inner-row" },
            [
              _c(
                "el-card",
                { staticStyle: { width: "100%" } },
                [
                  _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                    _c("span", [_vm._v(_vm._s(_vm.formHeadText))])
                  ]),
                  [1, 2, 3].includes(_vm.optStatus)
                    ? _c(
                        "el-form",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            disabled: _vm.optStatus === 2,
                            "label-position": "left",
                            "label-width": "90px"
                          },
                          model: {
                            value: _vm.docCategoryForm,
                            callback: function($$v) {
                              _vm.docCategoryForm = $$v
                            },
                            expression: "docCategoryForm"
                          }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SystemMaintenance.SerialNumber")
                              }
                            },
                            [
                              _c("el-input-number", {
                                attrs: { min: 0, "controls-position": "right" },
                                model: {
                                  value: _vm.docCategoryForm.level,
                                  callback: function($$v) {
                                    _vm.$set(_vm.docCategoryForm, "level", $$v)
                                  },
                                  expression: "docCategoryForm.level"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("SystemMaintenance.Code") }
                            },
                            [
                              _c("el-input", {
                                directives: [
                                  { name: "uppercase", rawName: "v-uppercase" }
                                ],
                                model: {
                                  value: _vm.docCategoryForm.code,
                                  callback: function($$v) {
                                    _vm.$set(_vm.docCategoryForm, "code", $$v)
                                  },
                                  expression: "docCategoryForm.code"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SystemMaintenance.ChineseName")
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.docCategoryForm.name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.docCategoryForm, "name", $$v)
                                  },
                                  expression: "docCategoryForm.name"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SystemMaintenance.EnglishName")
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.docCategoryForm.localName,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.docCategoryForm,
                                      "localName",
                                      $$v
                                    )
                                  },
                                  expression: "docCategoryForm.localName"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SystemMaintenance.Remark")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { type: "textarea", rows: 3 },
                                model: {
                                  value: _vm.docCategoryForm.remarks,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.docCategoryForm,
                                      "remarks",
                                      $$v
                                    )
                                  },
                                  expression: "docCategoryForm.remarks"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  [4, 5, 6].includes(_vm.optStatus)
                    ? _c(
                        "el-form",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            disabled: _vm.optStatus === 5,
                            "label-position": "left",
                            "label-width": "90px"
                          },
                          model: {
                            value: _vm.docTypeForm,
                            callback: function($$v) {
                              _vm.docTypeForm = $$v
                            },
                            expression: "docTypeForm"
                          }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SystemMaintenance.SerialNumber")
                              }
                            },
                            [
                              _c("el-input-number", {
                                attrs: { min: 0, "controls-position": "right" },
                                model: {
                                  value: _vm.docTypeForm.level,
                                  callback: function($$v) {
                                    _vm.$set(_vm.docTypeForm, "level", $$v)
                                  },
                                  expression: "docTypeForm.level"
                                }
                              }),
                              _c("el-checkbox", {
                                staticStyle: { "margin-left": "10px" },
                                attrs: {
                                  value: _vm.docTypeForm.defaultDocumentType,
                                  disabled: true,
                                  label: _vm.$t("CargoMsg.DefaultType")
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("SystemMaintenance.Code") }
                            },
                            [
                              _c("el-input", {
                                directives: [
                                  { name: "uppercase", rawName: "v-uppercase" }
                                ],
                                model: {
                                  value: _vm.docTypeForm.code,
                                  callback: function($$v) {
                                    _vm.$set(_vm.docTypeForm, "code", $$v)
                                  },
                                  expression: "docTypeForm.code"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SystemMaintenance.ChineseName")
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.docTypeForm.name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.docTypeForm, "name", $$v)
                                  },
                                  expression: "docTypeForm.name"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SystemMaintenance.EnglishName")
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.docTypeForm.localName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.docTypeForm, "localName", $$v)
                                  },
                                  expression: "docTypeForm.localName"
                                }
                              })
                            ],
                            1
                          ),
                          _vm.toExoSystemOC
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "SystemMaintenance.ExternalFileType"
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      model: {
                                        value: _vm.docTypeForm.externalFileType,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.docTypeForm,
                                            "externalFileType",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "docTypeForm.externalFileType"
                                      }
                                    },
                                    _vm._l(
                                      _vm.FileType.EXTERNAL_FILE_TYPES,
                                      function(item) {
                                        return _c("el-option", {
                                          key: item.code,
                                          attrs: {
                                            label: item.chineseName,
                                            value: item.code
                                          }
                                        })
                                      }
                                    ),
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          !_vm.toExoSystemOC
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "SystemMaintenance.ExternalFileType"
                                    )
                                  }
                                },
                                [
                                  _vm.optStatus === 0
                                    ? _c("el-input", {
                                        attrs: { disabled: true },
                                        model: {
                                          value: _vm.externalFileTypeList,
                                          callback: function($$v) {
                                            _vm.externalFileTypeList = $$v
                                          },
                                          expression: "externalFileTypeList"
                                        }
                                      })
                                    : _c("el-input", {
                                        attrs: { readonly: "" },
                                        on: { focus: _vm.showFileTypeDialog },
                                        model: {
                                          value: _vm.externalFileTypeList,
                                          callback: function($$v) {
                                            _vm.externalFileTypeList = $$v
                                          },
                                          expression: "externalFileTypeList"
                                        }
                                      })
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "SystemMaintenance.NecessaryScenario"
                                )
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.docTypeForm.essentialScene,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.docTypeForm,
                                      "essentialScene",
                                      $$v
                                    )
                                  },
                                  expression: "docTypeForm.essentialScene"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "SystemMaintenance.OriginalScenario"
                                )
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.docTypeForm.originalScene,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.docTypeForm,
                                      "originalScene",
                                      $$v
                                    )
                                  },
                                  expression: "docTypeForm.originalScene"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SystemMaintenance.Remark")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { type: "textarea", rows: 3 },
                                model: {
                                  value: _vm.docTypeForm.remarks,
                                  callback: function($$v) {
                                    _vm.$set(_vm.docTypeForm, "remarks", $$v)
                                  },
                                  expression: "docTypeForm.remarks"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                width: "calc(100% + 40px)",
                                "margin-left": "-20px",
                                padding: "10px 0 5px 20px",
                                border: "1px solid #DCDFE6",
                                "border-radius": "2px",
                                "margin-bottom": "10px"
                              }
                            },
                            [
                              _c("el-form-item", {
                                attrs: {
                                  label: _vm.$t(
                                    "SystemMaintenance.TypePermission"
                                  )
                                }
                              }),
                              _c(
                                "el-form-item",
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: { "padding-left": "10px" },
                                      attrs: { slot: "label" },
                                      slot: "label"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "SystemMaintenance.SpecifyRole"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _c("el-checkbox", {
                                    attrs: {
                                      label: _vm.$t(
                                        "SystemMaintenance.AllPositions"
                                      )
                                    },
                                    model: {
                                      value: _vm.docTypeForm.other,
                                      callback: function($$v) {
                                        _vm.$set(_vm.docTypeForm, "other", $$v)
                                      },
                                      expression: "docTypeForm.other"
                                    }
                                  }),
                                  _c("el-checkbox", {
                                    attrs: {
                                      label: _vm.$t("SystemMaintenance.Sales")
                                    },
                                    model: {
                                      value: _vm.docTypeForm.sales,
                                      callback: function($$v) {
                                        _vm.$set(_vm.docTypeForm, "sales", $$v)
                                      },
                                      expression: "docTypeForm.sales"
                                    }
                                  }),
                                  _c("el-checkbox", {
                                    attrs: {
                                      label: _vm.$t(
                                        "SystemMaintenance.Operation"
                                      )
                                    },
                                    model: {
                                      value: _vm.docTypeForm.op,
                                      callback: function($$v) {
                                        _vm.$set(_vm.docTypeForm, "op", $$v)
                                      },
                                      expression: "docTypeForm.op"
                                    }
                                  }),
                                  _c("el-checkbox", {
                                    attrs: {
                                      label: _vm.$t(
                                        "SystemMaintenance.CustomerService"
                                      )
                                    },
                                    model: {
                                      value: _vm.docTypeForm.csr,
                                      callback: function($$v) {
                                        _vm.$set(_vm.docTypeForm, "csr", $$v)
                                      },
                                      expression: "docTypeForm.csr"
                                    }
                                  }),
                                  _c("el-checkbox", {
                                    attrs: {
                                      label: _vm.$t(
                                        "SystemMaintenance.Documentation"
                                      )
                                    },
                                    model: {
                                      value: _vm.docTypeForm.dc,
                                      callback: function($$v) {
                                        _vm.$set(_vm.docTypeForm, "dc", $$v)
                                      },
                                      expression: "docTypeForm.dc"
                                    }
                                  }),
                                  _c("el-checkbox", {
                                    attrs: {
                                      label: _vm.$t("SeaExport.SalesOfGoods")
                                    },
                                    model: {
                                      value: _vm.docTypeForm.cargoSales,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.docTypeForm,
                                          "cargoSales",
                                          $$v
                                        )
                                      },
                                      expression: "docTypeForm.cargoSales"
                                    }
                                  }),
                                  _c("el-checkbox", {
                                    attrs: {
                                      label: _vm.$t(
                                        "SystemMaintenance.OverseasCustomerService"
                                      )
                                    },
                                    model: {
                                      value: _vm.docTypeForm.overseaOp,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.docTypeForm,
                                          "overseaOp",
                                          $$v
                                        )
                                      },
                                      expression: "docTypeForm.overseaOp"
                                    }
                                  }),
                                  _c("el-checkbox", {
                                    attrs: {
                                      label: _vm.$t(
                                        "SystemMaintenance.ShippingLineManager"
                                      )
                                    },
                                    model: {
                                      value: _vm.docTypeForm.planner,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.docTypeForm,
                                          "planner",
                                          $$v
                                        )
                                      },
                                      expression: "docTypeForm.planner"
                                    }
                                  }),
                                  _c("el-checkbox", {
                                    attrs: {
                                      label: _vm.$t(
                                        "CargoMsg.Cargo_userDefinedRole1"
                                      )
                                    },
                                    model: {
                                      value: _vm.docTypeForm.userDefinedRoleId1,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.docTypeForm,
                                          "userDefinedRoleId1",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "docTypeForm.userDefinedRoleId1"
                                    }
                                  }),
                                  _c("el-checkbox", {
                                    attrs: {
                                      label: _vm.$t(
                                        "CargoMsg.Cargo_userDefinedRole2"
                                      )
                                    },
                                    model: {
                                      value: _vm.docTypeForm.userDefinedRoleId2,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.docTypeForm,
                                          "userDefinedRoleId2",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "docTypeForm.userDefinedRoleId2"
                                    }
                                  }),
                                  _c("el-checkbox", {
                                    attrs: {
                                      label: _vm.$t(
                                        "SystemMaintenance.Consignor"
                                      )
                                    },
                                    model: {
                                      value: _vm.docTypeForm.customer,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.docTypeForm,
                                          "customer",
                                          $$v
                                        )
                                      },
                                      expression: "docTypeForm.customer"
                                    }
                                  }),
                                  _c("el-checkbox", {
                                    attrs: {
                                      label: _vm.$t("SystemMaintenance.Shipper")
                                    },
                                    model: {
                                      value: _vm.docTypeForm.shipper,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.docTypeForm,
                                          "shipper",
                                          $$v
                                        )
                                      },
                                      expression: "docTypeForm.shipper"
                                    }
                                  }),
                                  _c("el-checkbox", {
                                    attrs: {
                                      label: _vm.$t(
                                        "SystemMaintenance.Consignee"
                                      )
                                    },
                                    model: {
                                      value: _vm.docTypeForm.consignee,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.docTypeForm,
                                          "consignee",
                                          $$v
                                        )
                                      },
                                      expression: "docTypeForm.consignee"
                                    }
                                  }),
                                  _c("el-checkbox", {
                                    attrs: {
                                      label: _vm.$t(
                                        "SystemMaintenance.OverseasAgent"
                                      )
                                    },
                                    model: {
                                      value: _vm.docTypeForm.destinationAgent,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.docTypeForm,
                                          "destinationAgent",
                                          $$v
                                        )
                                      },
                                      expression: "docTypeForm.destinationAgent"
                                    }
                                  }),
                                  _c("el-checkbox", {
                                    attrs: {
                                      label: _vm.$t(
                                        "SystemMaintenance.BookingAgent"
                                      )
                                    },
                                    model: {
                                      value: _vm.docTypeForm.bookingAgent,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.docTypeForm,
                                          "bookingAgent",
                                          $$v
                                        )
                                      },
                                      expression: "docTypeForm.bookingAgent"
                                    }
                                  }),
                                  _c("el-checkbox", {
                                    attrs: {
                                      label: _vm.$t(
                                        "SystemMaintenance.ExternalAccess"
                                      )
                                    },
                                    model: {
                                      value: _vm.docTypeForm.shared,
                                      callback: function($$v) {
                                        _vm.$set(_vm.docTypeForm, "shared", $$v)
                                      },
                                      expression: "docTypeForm.shared"
                                    }
                                  }),
                                  _c("el-checkbox", {
                                    attrs: {
                                      label: _vm.$t(
                                        "SystemMaintenance.B2BCustomer"
                                      )
                                    },
                                    model: {
                                      value: _vm.docTypeForm.b2bCustomer,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.docTypeForm,
                                          "b2bCustomer",
                                          $$v
                                        )
                                      },
                                      expression: "docTypeForm.b2bCustomer"
                                    }
                                  }),
                                  _c("el-checkbox", {
                                    attrs: {
                                      label: _vm.$t(
                                        "SystemMaintenance.B2BDesignatedCargoAgent"
                                      )
                                    },
                                    model: {
                                      value:
                                        _vm.docTypeForm.b2bDesignationAgent,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.docTypeForm,
                                          "b2bDesignationAgent",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "docTypeForm.b2bDesignationAgent"
                                    }
                                  }),
                                  _c("el-checkbox", {
                                    attrs: {
                                      label: _vm.$t(
                                        "SystemMaintenance.B2BDestinationPortAgent"
                                      )
                                    },
                                    model: {
                                      value:
                                        _vm.docTypeForm.b2bDestinationAgent,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.docTypeForm,
                                          "b2bDestinationAgent",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "docTypeForm.b2bDestinationAgent"
                                    }
                                  }),
                                  _c("el-checkbox", {
                                    attrs: {
                                      label: _vm.$t(
                                        "SystemMaintenance.B2BConsignee"
                                      )
                                    },
                                    model: {
                                      value: _vm.docTypeForm.b2bConsignee,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.docTypeForm,
                                          "b2bConsignee",
                                          $$v
                                        )
                                      },
                                      expression: "docTypeForm.b2bConsignee"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: { "padding-left": "10px" },
                                      attrs: { slot: "label" },
                                      slot: "label"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "SystemMaintenance.DesignatedPersonnel"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _c("cargo-advance-select", {
                                    staticStyle: { width: "205px" },
                                    attrs: {
                                      "select-type":
                                        _vm.TYPE_NAMES.basic_data_User,
                                      fields: ["chineseName"],
                                      "filter-tag-names": ["chineseName"],
                                      "tag-name": "chineseName",
                                      disabled: _vm.optStatus === 5,
                                      filterable: "",
                                      multiple: "",
                                      "default-multiple-value": _vm.toNumArray(
                                        _vm.docTypeForm.designatePersons
                                      ),
                                      "options-width": "230px",
                                      placeholder: _vm.$t(
                                        "Message.PleaseSelect"
                                      )
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        _vm.docTypeForm.designatePersons = _vm.toTxt(
                                          p.value
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { "label-width": "0" } },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { "padding-left": "10px" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "SystemMaintenance.CheckPrivilegePersonLabel"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-radio-group",
                                    {
                                      staticStyle: { "margin-left": "30px" },
                                      model: {
                                        value:
                                          _vm.docTypeForm.checkPrivilegePerson,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.docTypeForm,
                                            "checkPrivilegePerson",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "docTypeForm.checkPrivilegePerson"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        { attrs: { label: true } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("SystemMaintenance.Yes")
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-radio",
                                        { attrs: { label: false } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("SystemMaintenance.No")
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              [4, 5, 6].includes(_vm.optStatus) && _vm.showTemplateRuleConfig
                ? _c(
                    "el-card",
                    { staticStyle: { width: "60%", "margin-left": "60px" } },
                    [
                      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("SystemMaintenance.CustomTemplateName")
                            )
                          )
                        ])
                      ]),
                      [4, 5, 6].includes(_vm.optStatus)
                        ? _c(
                            "el-form",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                disabled: _vm.optStatus === 5,
                                "label-position": "left",
                                "label-width": "90px"
                              },
                              model: {
                                value: _vm.docTypeForm,
                                callback: function($$v) {
                                  _vm.docTypeForm = $$v
                                },
                                expression: "docTypeForm"
                              }
                            },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "SystemMaintenance.TemplateOutputName"
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "template-rule-name-select",
                                      model: {
                                        value: _vm.docTypeForm.templateRuleZero,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.docTypeForm,
                                            "templateRuleZero",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "docTypeForm.templateRuleZero"
                                      }
                                    },
                                    _vm._l(
                                      _vm.templateRuleNameOptions,
                                      function(item) {
                                        return _c("el-option", {
                                          key: item.value,
                                          attrs: {
                                            label: item.name,
                                            value: item.value
                                          }
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "template-rule-name-select",
                                      model: {
                                        value: _vm.docTypeForm.templateRuleOne,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.docTypeForm,
                                            "templateRuleOne",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "docTypeForm.templateRuleOne"
                                      }
                                    },
                                    _vm._l(
                                      _vm.templateRuleNameOptions,
                                      function(item) {
                                        return _c("el-option", {
                                          key: item.value,
                                          attrs: {
                                            label: item.name,
                                            value: item.value
                                          }
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "template-rule-name-select",
                                      model: {
                                        value: _vm.docTypeForm.templateRuleTwo,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.docTypeForm,
                                            "templateRuleTwo",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "docTypeForm.templateRuleTwo"
                                      }
                                    },
                                    _vm._l(
                                      _vm.templateRuleNameOptions,
                                      function(item) {
                                        return _c("el-option", {
                                          key: item.value,
                                          attrs: {
                                            label: item.name,
                                            value: item.value
                                          }
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "template-rule-name-select",
                                      model: {
                                        value:
                                          _vm.docTypeForm.templateRuleThree,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.docTypeForm,
                                            "templateRuleThree",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "docTypeForm.templateRuleThree"
                                      }
                                    },
                                    _vm._l(
                                      _vm.templateRuleNameOptions,
                                      function(item) {
                                        return _c("el-option", {
                                          key: item.value,
                                          attrs: {
                                            label: item.name,
                                            value: item.value
                                          }
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "template-rule-name-select",
                                      model: {
                                        value: _vm.docTypeForm.templateRuleFour,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.docTypeForm,
                                            "templateRuleFour",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "docTypeForm.templateRuleFour"
                                      }
                                    },
                                    _vm._l(
                                      _vm.templateRuleNameOptions,
                                      function(item) {
                                        return _c("el-option", {
                                          key: item.value,
                                          attrs: {
                                            label: item.name,
                                            value: item.value
                                          }
                                        })
                                      }
                                    ),
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SystemMaintenance.Delimiter")
                                  }
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      model: {
                                        value: _vm.docTypeForm.separators,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.docTypeForm,
                                            "separators",
                                            $$v
                                          )
                                        },
                                        expression: "docTypeForm.separators"
                                      }
                                    },
                                    [
                                      _c("el-radio", { attrs: { label: 0 } }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "SystemMaintenance.Underscore_"
                                            )
                                          )
                                        )
                                      ]),
                                      _c("el-radio", { attrs: { label: 1 } }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("SystemMaintenance.Hyphen")
                                          )
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SystemMaintenance.Example")
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "font-size": "12px",
                                        "font-weight": "normal"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.templateRuleNameExample)
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "SystemMaintenance.AutomPrintDefaultFileType"
                                    ),
                                    "label-width": "auto"
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "auto" },
                                      attrs: { clearable: "" },
                                      model: {
                                        value:
                                          _vm.docTypeForm
                                            .autoPrintDefaultFileType,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.docTypeForm,
                                            "autoPrintDefaultFileType",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "docTypeForm.autoPrintDefaultFileType"
                                      }
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: {
                                          label: "PDF",
                                          value: "ExportPDF"
                                        }
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: "WORD",
                                          value: "ExportWORD"
                                        }
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: "EXCEL",
                                          value: "ExportXLS"
                                        }
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: "PPT",
                                          value: "ExportPPT"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c("el-alert", {
                        staticStyle: { "margin-top": "35px" },
                        attrs: {
                          title: _vm.$t(
                            "SystemMaintenance.NoteTemplateNameAccordingNeeds"
                          ),
                          type: "info",
                          center: "",
                          "show-icon": "",
                          closable: false
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          ref: "docTypeTreeDialog",
          staticClass: "app-main-inner",
          attrs: {
            visible: _vm.docTypeTree.visible,
            title: _vm.$t("CargoMsg.SetDefaultType"),
            width: "400px",
            "close-on-click-modal": false,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.docTypeTree, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "app-main-inner-row" },
            [
              _c("cargo-ag-grid", {
                staticStyle: {
                  width: "350px",
                  height: "300px",
                  "padding-left": "2px"
                },
                attrs: {
                  "show-side-bar": false,
                  "grid-params": _vm.docTypeTree.girdParams,
                  "grid-options": _vm.docTypeTree.gridOptions,
                  "row-data": _vm.docTypeTree.rowData
                },
                on: {
                  "update:gridParams": function($event) {
                    return _vm.$set(_vm.docTypeTree, "girdParams", $event)
                  },
                  "update:grid-params": function($event) {
                    return _vm.$set(_vm.docTypeTree, "girdParams", $event)
                  },
                  gridReady: function(params) {
                    _vm.docTypeTree.gridApi = params.api
                  }
                }
              })
            ],
            1
          ),
          _c(
            "span",
            {
              staticStyle: { "padding-right": "30px" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.saveDefaultType }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.ok")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.docTypeTree.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _vm.fileTypeEditor.visible
        ? _c("assign-file-type-editor", {
            attrs: {
              visible: _vm.fileTypeEditor.visible,
              "file-id": _vm.fileTypeEditor.fileId,
              "data-list": _vm.fileTypeEditor.dataList,
              "file-category": _vm.fileTypeEditor.fileCategory
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.fileTypeEditor, "visible", $event)
              },
              saveFileType: _vm.onSaveFileType
            }
          })
        : _vm._e(),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.fileSyncRuleDialog.visible,
            title: _vm.$t("SystemMaintenance.SetFileSyncRule"),
            width: "600px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.fileSyncRuleDialog, "visible", $event)
            }
          }
        },
        [
          _c("div", { staticClass: "details-view" }, [
            _c(
              "div",
              { staticClass: "main-content" },
              [
                _c(
                  "el-form",
                  {
                    attrs: { "label-width": "100px", "label-position": "right" }
                  },
                  [
                    _c(
                      "el-form-item",
                      [
                        _c("line-label", {
                          staticClass: "title",
                          staticStyle: {
                            "font-size": "12px",
                            "margin-bottom": "0"
                          },
                          attrs: {
                            slot: "label",
                            label: _vm.$t("SystemMaintenance.BusinessModel")
                          },
                          slot: "label"
                        }),
                        _c("el-checkbox", {
                          attrs: {
                            label: _vm.$t("SystemMaintenance.CrossDelegation")
                          },
                          on: { change: _vm.onCrossTrustModelChange },
                          model: {
                            value: _vm.fileSyncRuleDialog.form.isCrossTrustMode,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.fileSyncRuleDialog.form,
                                "isCrossTrustMode",
                                $$v
                              )
                            },
                            expression:
                              "fileSyncRuleDialog.form.isCrossTrustMode"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c("line-label", {
                          attrs: {
                            slot: "label",
                            label: _vm.$t("SystemMaintenance.SyncDirection")
                          },
                          slot: "label"
                        }),
                        _c("el-checkbox", {
                          attrs: {
                            disabled: !_vm.fileSyncRuleDialog.form
                              .isCrossTrustMode,
                            label: _vm.$t("SystemMaintenance.PrincipalOperator")
                          },
                          model: {
                            value: _vm.fileSyncRuleDialog.form.isTrustToOperate,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.fileSyncRuleDialog.form,
                                "isTrustToOperate",
                                $$v
                              )
                            },
                            expression:
                              "fileSyncRuleDialog.form.isTrustToOperate"
                          }
                        }),
                        _c("el-checkbox", {
                          attrs: {
                            disabled: !_vm.fileSyncRuleDialog.form
                              .isCrossTrustMode,
                            label: _vm.$t("SystemMaintenance.OperatorClient")
                          },
                          model: {
                            value: _vm.fileSyncRuleDialog.form.isOperateToTrust,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.fileSyncRuleDialog.form,
                                "isOperateToTrust",
                                $$v
                              )
                            },
                            expression:
                              "fileSyncRuleDialog.form.isOperateToTrust"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c("line-label", {
                          attrs: {
                            slot: "label",
                            label: _vm.$t("SystemMaintenance.SyncMode")
                          },
                          slot: "label"
                        }),
                        _c(
                          "el-radio-group",
                          {
                            attrs: {
                              disabled: !_vm.fileSyncRuleDialog.form
                                .isCrossTrustMode
                            },
                            model: {
                              value:
                                _vm.fileSyncRuleDialog.form.trustSyncFileMode,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.fileSyncRuleDialog.form,
                                  "trustSyncFileMode",
                                  $$v
                                )
                              },
                              expression:
                                "fileSyncRuleDialog.form.trustSyncFileMode"
                            }
                          },
                          [
                            _c("el-radio", { attrs: { label: 1 } }, [
                              _vm._v(
                                _vm._s(_vm.$t("SystemMaintenance.ManualSync"))
                              )
                            ]),
                            _c("el-radio", { attrs: { label: 2 } }, [
                              _vm._v(
                                _vm._s(_vm.$t("SystemMaintenance.AutoSync"))
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm.fileSyncRuleDialog.form.trustSyncFileMode === 1
                      ? _c(
                          "el-form-item",
                          [
                            _c("line-label", {
                              attrs: {
                                slot: "label",
                                label:
                                  _vm.$t("CargoMsg.Cargo_Append") +
                                  _vm.$t("CargoMsg.Cargo_Status") +
                                  "："
                              },
                              slot: "label"
                            }),
                            _c("cargo-advance-select", {
                              staticStyle: { width: "300px" },
                              attrs: {
                                disabled: !_vm.fileSyncRuleDialog.form
                                  .isCrossTrustMode,
                                filterable: "",
                                "static-options": _vm.jobStates,
                                "default-multiple-value":
                                  _vm.ctmSyncFileApprovedDocArray,
                                multiple: true,
                                "tag-name": "chineseName",
                                "tag-value": "code",
                                "custom-label": function(item) {
                                  return "" + item.chineseName
                                }
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.ctmSyncFileApprovedDocArray = p.code
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _c("el-divider"),
                    _c(
                      "el-form-item",
                      [
                        _c("line-label", {
                          staticClass: "title",
                          staticStyle: {
                            "font-size": "12px",
                            "margin-bottom": "0"
                          },
                          attrs: {
                            slot: "label",
                            label: _vm.$t("SystemMaintenance.BusinessModel")
                          },
                          slot: "label"
                        }),
                        _c("el-checkbox", {
                          attrs: {
                            label: _vm.$t("SystemMaintenance.ExportToImport")
                          },
                          on: { change: _vm.onExportToImportModelChange },
                          model: {
                            value:
                              _vm.fileSyncRuleDialog.form.isExportToImportMode,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.fileSyncRuleDialog.form,
                                "isExportToImportMode",
                                $$v
                              )
                            },
                            expression:
                              "fileSyncRuleDialog.form.isExportToImportMode"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c("line-label", {
                          attrs: {
                            slot: "label",
                            label: _vm.$t("SystemMaintenance.SyncDirection")
                          },
                          slot: "label"
                        }),
                        _c("el-checkbox", {
                          attrs: {
                            disabled: !_vm.fileSyncRuleDialog.form
                              .isExportToImportMode,
                            label: _vm.$t("SystemMaintenance.ExporterImporter")
                          },
                          model: {
                            value: _vm.fileSyncRuleDialog.form.isExportToImport,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.fileSyncRuleDialog.form,
                                "isExportToImport",
                                $$v
                              )
                            },
                            expression:
                              "fileSyncRuleDialog.form.isExportToImport"
                          }
                        }),
                        _c("el-checkbox", {
                          attrs: {
                            disabled: !_vm.fileSyncRuleDialog.form
                              .isExportToImportMode,
                            label: _vm.$t("SystemMaintenance.ImporterExporter")
                          },
                          model: {
                            value: _vm.fileSyncRuleDialog.form.isImportToExport,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.fileSyncRuleDialog.form,
                                "isImportToExport",
                                $$v
                              )
                            },
                            expression:
                              "fileSyncRuleDialog.form.isImportToExport"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c("line-label", {
                          attrs: {
                            slot: "label",
                            label: _vm.$t("SystemMaintenance.SyncMode")
                          },
                          slot: "label"
                        }),
                        _c(
                          "el-radio-group",
                          {
                            attrs: {
                              disabled: !_vm.fileSyncRuleDialog.form
                                .isExportToImportMode
                            },
                            model: {
                              value:
                                _vm.fileSyncRuleDialog.form
                                  .exportImportSyncFileMode,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.fileSyncRuleDialog.form,
                                  "exportImportSyncFileMode",
                                  $$v
                                )
                              },
                              expression:
                                "fileSyncRuleDialog.form.exportImportSyncFileMode"
                            }
                          },
                          [
                            _c("el-radio", { attrs: { label: 1 } }, [
                              _vm._v(
                                _vm._s(_vm.$t("SystemMaintenance.ManualSync"))
                              )
                            ]),
                            _c("el-radio", { attrs: { label: 2 } }, [
                              _vm._v(
                                _vm._s(_vm.$t("SystemMaintenance.AutoSync"))
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm.fileSyncRuleDialog.form.exportImportSyncFileMode === 1
                      ? _c(
                          "el-form-item",
                          [
                            _c("line-label", {
                              attrs: {
                                slot: "label",
                                label:
                                  _vm.$t("CargoMsg.Cargo_Append") +
                                  _vm.$t("CargoMsg.Cargo_Status") +
                                  "："
                              },
                              slot: "label"
                            }),
                            _c("cargo-advance-select", {
                              staticStyle: { width: "300px" },
                              attrs: {
                                disabled: !_vm.fileSyncRuleDialog.form
                                  .isExportToImportMode,
                                filterable: "",
                                "static-options": _vm.jobStates,
                                "default-multiple-value":
                                  _vm.etiSyncFileApprovedDocArray,
                                multiple: true,
                                "tag-name": "chineseName",
                                "tag-value": "code",
                                "custom-label": function(item) {
                                  return "" + item.chineseName
                                }
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.etiSyncFileApprovedDocArray = p.code
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.saveFileSyncRule }
                },
                [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Save")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.fileSyncRuleDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Cancel")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }